import styled from 'styled-components';
import { ReactComponent as Loader } from '../../assets/icons/loader.svg';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 60px 1fr;
  background-color: #eff3f6;
`;

export const Header = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 230px 180px 180px 1fr;
  border-bottom: 1px solid #c5d0de;
  background-color: #ffffff;
  justify-items: center;
  align-items: center;
`;

export const HeaderTitle = styled.div`
  width: 100%;
  border-right: 1px solid #c5d0de;
  font-family: Rubik;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 36px;
  color: #354052;
  text-align: center;
`;

export const Card = styled.div`
  width: 100%;
  height: 100%;
  background: #ffffff;
  border: 1px solid #c5d0de;
  box-sizing: border-box;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  display: grid;
  grid-template-rows: repeat(auto-fill, 60px);
  padding: 0 20px 0 20px;
`;

export const Table = styled.div`
  height: 100%;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: #7f8fa4;
    border-radius: 10px;
  }
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 3fr 4fr 2fr 2fr 4fr;
  align-items: center;
  border-bottom: 1px solid #c5d0de;
  padding-left: 25px;
`;

export const TableHeaderTitle = styled.div`
  font-weight: 500;
  color: #354052;
  font-size: 14px;
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 3fr 4fr 2fr 2fr 4fr;
  align-items: center;
  border-bottom: 1px solid #c5d0de;
  padding-left: 25px;
  height: 100%;
`;

export const TableCell = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 25px;
`;

export const ActionsCell = styled.div`
  max-width: 400px;
  display: grid;
  grid-template-columns: 30px auto auto;
`;

export const StatusCell = styled.div`
  display: grid;
  grid-template-columns: 30px auto;
`;

export const AnimatedLoader = styled(Loader)`
  animation: rotation 2s infinite linear;

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

export const ClickableText = styled.div`
  color: #2ea1f8;
  cursor: pointer;
`;
